import { withApp } from "@/components/App"
import Slice from "@/document_editor/Slice"

import Editor from "./Editor"

export default withApp(Editor, { slices: [Slice] })
